import { render, staticRenderFns } from "./ComponentTask.vue?vue&type=template&id=22b48ed2&"
import script from "./ComponentTask.vue?vue&type=script&lang=ts&"
export * from "./ComponentTask.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports